import { render, staticRenderFns } from "./active-account.vue?vue&type=template&id=ab54d51e"
import script from "./active-account.vue?vue&type=script&lang=js"
export * from "./active-account.vue?vue&type=script&lang=js"
import style0 from "./active-account.vue?vue&type=style&index=0&id=ab54d51e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports